import 'swiper/css';
import Swiper from 'swiper';

export default () => {
  const init = () => {
    if (!customElements.get("product-slider")) {
      customElements.define("product-slider", ProductSlider);
    }
  };

  class ProductSlider extends HTMLElement {
    constructor() {
      super();
      this.mainSlider = this.querySelector(".js-product-slider");
      this.slidesPerViewMob = +this.getAttribute("slidesPerViewMob") || 1.2;
      this.slidesPerViewTablet = +this.getAttribute("slidesPerViewTablet") || 3.2;
      this.slidesPerView = +this.getAttribute("slidesPerView") || 4;
    }

    initializeSwiper() {    
      if (this.mainSlider) {
        // eslint-disable-next-line
        new Swiper(this.mainSlider, {
          direction: 'horizontal',
          centeredSlides: false,
          slidesPerView:  this.slidesPerViewMob,
          autoHeight: true,
          spaceBetween: 0,
          loop: true,
          breakpoints: {
            575: {
              loop: false,
              slidesPerView: this.slidesPerViewTablet,
              autoHeight: true,
              centeredSlides: false
            },
            1024: {
                loop: false,
                slidesPerView: this.slidesPerView,
                autoHeight: true,
                centeredSlides: false
            }
          }
        });
      }
    }

    connectedCallback() {
      this.initializeSwiper();
    }
  }

  init();
}